import { h } from 'preact';

export default function Loader({ message = 'Loading...' }) {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 z-50 flex items-center justify-center">
      <div className="text-center">
        {/* Spinning loader */}
        <div className="inline-block relative w-20 h-20">
          <div className="absolute border-4 border-gray-300 border-t-coit-red rounded-full w-20 h-20 animate-spin"></div>
        </div>

        {/* Loading message */}
        <p className="mt-4 text-lg text-gray-700 font-medium">{message}</p>
      </div>
    </div>
  );
}
